import axiosInstance from '@/utils/axios';
import {SharedListUrlOptions} from '@/utils/generateSharedListUrl';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';

/**
 * Uses the configured (token-injecting) axios instance instead of
 * `window.open`, which can't carry the auth headers the endpoint requires.
 */
export default async function downloadAuthenticatedCsv(
  type: SharedListUrlOptions['type'],
  refId: string,
  fileName = `creators__${new Date().toISOString().slice(0, 10)}.csv`
): Promise<void> {
  try {
    const {data} = await axiosInstance.get<Blob>('/shared_list_creators/csv', {
      params: {type, ref_id: refId},
      responseType: 'blob',
    });

    const objectUrl = URL.createObjectURL(data);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(objectUrl);
  } catch {
    raiseFlashMessage({
      status: 'error',
      message: translate('Download failed — please try again'),
    });
  }
}
